import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import Icon from '../Icon'

export const BoxStyled = styled.div`
  width: 33.3333%;
  &:first-child:nth-last-child(1) {
    width: 50%;
  }
  &:first-child:nth-last-child(2),
    &:first-child:nth-last-child(2) ~ div {
      width: 50%;
  }
`

export const BoxWrapperLink = styled(Link)`
  display: block;
  padding: 12px;
  margin-top: 6px;
  margin-left: 2px;
  margin-right: 2px;
  border-radius: 4px;
  border: ${({ theme }) => `2px solid ${theme.white}`};
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 6px 18px 0 ${({ theme }) => theme.blueyGrey22};
  height: calc(100% - 6px);
  pointer-events: none;
   ${({ active }) =>
    active &&
    css`
          border: ${({ theme }) => `2px solid ${theme.whiteTwo}`};
          background-color: ${({ theme }) => theme.whiteTwo};
          pointer-events: auto;
          cursor: pointer;
        `
  };
  ${({ active, bordercolor }) =>
    (active && bordercolor) &&
    css`
          border: ${({ bordercolor }) => `2px solid ${bordercolor}`};
        `
  };
`

export const BoxWrapperHref = styled.a`
  display: block;
  padding: 12px;
  margin-top: 6px;
  margin-left: 2px;
  margin-right: 2px;
  border-radius: 4px;
  border: ${({ theme }) => `2px solid ${theme.white}`};
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 6px 18px 0 ${({ theme }) => theme.blueyGrey22};
  height: calc(100% - 6px);
  pointer-events: none;
   ${({ active }) =>
    active &&
    css`
          border: ${({ theme }) => `2px solid ${theme.whiteTwo}`};
          background-color: ${({ theme }) => theme.whiteTwo};
          pointer-events: auto;
          cursor: pointer;
        `
  };
  ${({ active, bordercolor }) =>
    (active && bordercolor) &&
    css`
          border: ${({ bordercolor }) => `2px solid ${bordercolor}`};
        `
  };
`

export const BoxTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  min-height: 32px;
  color: ${(props) => props.active ? props.theme.greyishBrown : props.theme.veryLightPink};
  ${props =>
    props.title === null &&
    css`
           width: 60px;
           min-height: 16px;
           background: ${({ theme }) => theme.blueyGrey22};
           border-radius: 2px;
        `
  };
`

export const BoxContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: ${({ autoHeightContent }) => autoHeightContent ? 'auto' : '60px'};
  margin-top: 10px;
  ${({ noMarginConent }) =>
    noMarginConent &&
    css`
          margin: 0;
        `
  };
`

export const BoxItem = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
    min-height: 22px;
`

export const BoxItemText = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.brownGrey};
    margin-left: 10px;
`
export const BoxItemBottomText = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.brownGrey};
`

export const StyledIcon = styled(Icon).attrs(({ theme, height, width }) => ({
  color: theme.veryLightPink,
  height: height,
  width
}))``
